import type { LocationDescriptorObject } from "history";

import type { TypedAction } from "../../../generic/redux/TypedRedux";
import type { ViewMode } from "../../../routes/Routes";

import { MERGE_VIEW_PARAMS, STORE_LOCATION } from "./RouteActionTypes";
import type { SearchParamsInput } from "./SearchParams";

export interface StoreLocation extends TypedAction<typeof STORE_LOCATION> {
	location: LocationDescriptorObject;
}

export function storeLocation(location: LocationDescriptorObject): StoreLocation {
	return {
		type: STORE_LOCATION,
		location,
	};
}

export interface MergeViewParams extends TypedAction<typeof MERGE_VIEW_PARAMS> {
	mode?: ViewMode;
	search?: SearchParamsInput;
}

interface ViewParams extends SearchParamsInput {
	mode?: ViewMode;
}

/**
 * The action helps to merge params to any possible StackState view+explore-subview combination.
 * More specifically (view|explore|component)*explore-subview = 6 different paths.
 * The idea is that params will merge to the current path, so you don't need to detect
 * which path you currently are when you call the action.
 */
export function mergeViewParams({ mode, ...search }: ViewParams): MergeViewParams {
	return {
		type: MERGE_VIEW_PARAMS,
		mode,
		search,
	};
}
